/* eslint-disable jsx-a11y/anchor-is-valid */
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import { NavHashLink } from "react-router-hash-link";
const Footer = () => {
  return (
    <div
      className="container-fluid bg-dark text-light footer pt-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <h4 className="text-white mb-3">About STPI</h4>
            <a
              className="btn btn-link"
              href="https://stpi.in/en/about-stpi"
              target="_blank"
              rel="noreferrer"
            >
              About STPI
            </a>
            <a
              className="btn btn-link"
              href="https://stpi.in/en/about-stpi#ObjectivesofSTPI"
              target="_blank"
              rel="noreferrer"
            >
              Objectives of STPI
            </a>
            <a
              className="btn btn-link"
              href="https://stpi.in/en/about-stpi#FunctionsofSTPI"
              target="_blank"
              rel="noreferrer"
            >
              Functions of STPI
            </a>
            <a
              className="btn btn-link"
              href="https://stpi.in/en/about-stpi#QualityObjectives"
              target="_blank"
              rel="noreferrer"
            >
              Quality Objective
            </a>
            <a
              className="btn btn-link"
              href="https://stpi.in/en/about-stpi#stpiCenters"
              target="_blank"
              rel="noreferrer"
            >
              STPI Centres
            </a>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <h4 className="text-white mb-3">Incubation Services</h4>
            {/* <a
              className="btn btn-link"
              href="https://stpi.in/en/incubation-services"
              target="_blank"
              rel="noreferrer"
            >
              About Incubation Services
            </a> */}
            <NavHashLink className="btn btn-link" to="/#key-statistics">
              Key Statistics
            </NavHashLink>
            <NavHashLink className="btn btn-link" to="/#key-features">
              Key Features
            </NavHashLink>
            <NavHashLink className="btn btn-link" to="/#centers-list-slider">
              Centers
            </NavHashLink>
            {/* <NavHashLink className="btn btn-link" to="/#key-statistics">
              Discounts
            </NavHashLink> */}
            <NavHashLink className="btn btn-link" to="/#faqs">
              FAQs
            </NavHashLink>
          </div>
          <div className="col-12 col-sm-12 col-md-4 col-lg-6">
            <h4 className="text-white mb-3">Headquarters</h4>
            <p className="mb-2">
              <FaLocationDot className="me-3" />
              Software Technology Parks of India, 1st Floor, Plate B, Office
              Block-1, East Kidwai Nagar, New Delhi-110023
            </p>
            <p className="mb-2">
              <FaPhone className="me-3" />
              +91-11-24628081
            </p>
            {/* <p className="mb-2"><i className="fa fa-envelope me-3"></i>info@example.com</p> */}
            <div className="d-flex pt-2">
              <a className="btn btn-outline-light btn-social" href="https://x.com/stpiindia">
                <i className="fab fa-twitter"></i>
              </a>
              <a className="btn btn-outline-light btn-social" href="https://www.facebook.com/stpiindia/">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a className="btn btn-outline-light btn-social" href="https://www.youtube.com/stpiindia">
                <i className="fab fa-youtube"></i>
              </a>
              <a className="btn btn-outline-light btn-social" href="https://www.linkedin.com/company/stpiindia/">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="copyright">
          <div className="row">
            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
              <a
                className="me-2"
                href="https://stpi.in"
                target="_blank"
                rel="noreferrer"
              >
                &copy; STPI
              </a>
              {/*<!--/*** This template is free as long as you keep the footer author’s credit link/attribution link/backlink. If you'd like to use the template without the footer author’s credit link/attribution link/backlink, you can purchase the Credit Removal License from "https://htmlcodex.com/credit-removal". Thank you for your support. */}
              Designed By{" "}
              <a
                className=""
                href="https://htmlcodex.com"
                target="_blank"
                rel="noreferrer"
              >
                HTML Codex
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
